module.exports = __webpack_public_path__ + "media/components/src/assets/images/arrow-book-detail/question-0fea1af8884a925e02d0c69938691113.svg";